import { useLocation } from 'react-router-dom';
import OrgSwitcher from './OrgSwitcher';
import ThemeToggle from '@/components/ThemeToggle';
import { Menu as MenuIcon } from '@/components/icons';

const TITLES: Record<string, string> = {
  '/':             'Leaderboard',
  '/calendar':     'Calendar',
  '/profiles':     'Profiles',
  '/repositories': 'Repositories',
};

interface Props {
  onMenuClick: () => void;
}

export default function TopBar({ onMenuClick }: Props) {
  const loc = useLocation();
  const base = '/' + loc.pathname.split('/')[1];
  const title = TITLES[base] ?? TITLES[loc.pathname] ?? '';

  return (
    <header className="sticky top-0 z-30 h-12 border-b bg-bg/85 backdrop-blur-md flex items-center justify-between px-3 sm:px-5">
      <div className="flex items-center gap-2 min-w-0">
        <button
          type="button"
          onClick={onMenuClick}
          className="icon-btn md:hidden shrink-0"
          aria-label="Open navigation menu"
        >
          <MenuIcon />
        </button>
        <span className="text-[13px] font-semibold text-fg truncate">{title}</span>
      </div>
      <div className="flex items-center gap-1.5 min-w-0">
        <OrgSwitcher />
        <div className="h-5 w-px bg-fg/10" />
        <ThemeToggle />
      </div>
    </header>
  );
}

